import { render, staticRenderFns } from "./Fashion.vue?vue&type=template&id=df9c7176&scoped=true&"
import script from "./Fashion.vue?vue&type=script&lang=js&"
export * from "./Fashion.vue?vue&type=script&lang=js&"
import style0 from "./Fashion.vue?vue&type=style&index=0&id=df9c7176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9c7176",
  null
  
)

export default component.exports